module.exports = __webpack_public_path__ + "img/envelope3.ae0c3a65.jpg";